import { ClientSDK } from '@easeltv/client-sdk';
import { error, log } from '@easeltv/logger';

import { useDictionaryObject } from '../../../hooks/useDictionary/useDictionary';
import DumbSignOutModal from './SignOutModal.dumb';

/* ---------------------------------- Types --------------------------------- */

interface SignOutModalI {
    /** Callback to close the modal */
    closeModal: () => void;

    /** Callback to logout */
    logoutFn: typeof ClientSDK.prototype.logout;
}

/* -------------------------------- Component ------------------------------- */

const SignOutModal = ({ closeModal, logoutFn }: SignOutModalI) => {
    const labels = useDictionaryObject({
        title: 'logout.title',
        confirmation: 'logout.confirmation',
        confirmButton: 'logout.confirmation.button.confirm',
        cancelButton: 'logout.confirmation.button.cancel',
    });

    const logout = async () => {
        const result = await logoutFn();
        log(result);
        if (!result.ok) {
            error(result);
        } else {
            // track user signed out before redirect
            window.analytics.trigger({
                type: 'account.signed-out',
            });

            closeModal();
        }
    };

    return (
        <DumbSignOutModal labels={labels} logout={logout} cancel={closeModal} />
    );
};

/* --------------------------------- Export --------------------------------- */

export default SignOutModal;
